import { InternalMfaStatus } from "../types/mfa";

export type InternalMfaChallengeMode = "none" | "enrollment" | "verification";

export function getInternalMfaChallengeMode(
    status: InternalMfaStatus
): InternalMfaChallengeMode {
    if (!status.required || status.exempt || status.verified) {
        return "none";
    }

    return status.enrolled ? "verification" : "enrollment";
}
